'use client';
import Image from 'next/image';
import Link from 'next/link';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import aboutAolCourses from '../../../data/aboutAolCourses';
import aboutKeyInitiatives from '../../../data/aboutKeyInitiatives';
export default function AboutUsPage() {
  const aolCoursesSliderSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    centerPadding: '60px',
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
          infinite: true,
          slidesToShow: 2.1,
          slidesToScroll: 1,
          swipeToSlide: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          //variableWidth: true,
        },
      },
    ],
  };
  return (
    <main className="page-aboutUs">
      <section className="section-first">
        <div className="container">
          <div className="page-name">ABOUT</div>
          <h2 className="section-title font-work-sans text-center">
            Movement towards a <strong>happier, stress-free world</strong>
          </h2>
          <div className="top-row">
            <div className="first-col">
              <p className="top-row-text1">
                The Art of Living is one of the largest non-profit organizations
                in the world, founded in 1981 by renowned spiritual teacher and
                humanitarian <b>Gurudev Sri Sri Ravi Shankar</b>
              </p>
              <Image
                src="/images/GurudevImage.jpeg"
                alt="gurudev"
                className="gurudev-image"
                width={280}
                height={869}
              />
            </div>
            <div className="second-col">
              <p className="top-row-text2">
                It is committed to uplifting and empowering individuals and
                communities through a blend of ancient wisdom and modern
                science, with a particular focus on stress reduction and mental
                well-being
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section-mission">
        <div className="container">
          <h2 className="section-title font-work-sans d-md-none mb-3">
            <strong>Mission and Vision</strong>
          </h2>
          <div className="mission-vision">
            <Image
              src="/images/MissionAndVision.jpeg"
              alt="gurudev"
              className="mission-vision-image"
              width={684}
              height={370}
            />
            <div className="mission-vision-content">
              <h2 className="section-title font-work-sans d-none d-md-block">
                <strong>Mission and Vision</strong>
              </h2>
              <div className="mission-vision-text">
                The foundation's mission is to create a happier, stress-free
                world by providing tools for personal transformation. The vision
                is to foster a global community that seeks positive change and
                well-being for all individuals.
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="aol-courses">
        <div className="container">
          <h2 className="section-title font-work-sans">
            <strong>Art of Living Courses</strong>
          </h2>
          <div className="aol-courses-tiles d-none d-md-block">
            {aboutAolCourses.map((course, index) => (
              <div key={index} className="aol-courses-tile">
                {' '}
                <Image
                  src={course.image}
                  alt={course.title}
                  width={274}
                  height={307}
                  className="course-tile-image"
                />{' '}
                <Link className="course-link" href={course.link}>
                  {course.title}
                </Link>
              </div>
            ))}
          </div>
          <div className="aol-courses-tiles aol-courses-slider d-md-none">
            <Slider {...aolCoursesSliderSettings}>
              {aboutAolCourses.map((course, index) => (
                <div key={index} className="aol-courses-tile">
                  {' '}
                  <Image
                    src={course.image}
                    alt={course.title}
                    width={274}
                    height={307}
                    className="course-tile-image"
                  />{' '}
                  <Link className="course-link" href={course.link}>
                    {course.title}
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
          <div className="aol-courses-content">
            <p>
              The Art of Living offers transformative, evidence-based techniques
              and courses that facilitate significant stress reduction. These
              tools also foster deep and profound inner peace, happiness, and
              well-being for all individuals.
            </p>
            <p>
              The impact of these programs is wide-reaching, having resonated
              with millions in over 180 countries. Participants from diverse
              backgrounds and walks of life have reported remarkable
              transformations, ranging from heightened mental clarity and relief
              from anxiety to a more joyful and fulfilling existence. In
              essence, the Art of Living's multifaceted programs act as a
              catalyst for positive change, equipping individuals with the
              necessary tools to craft a life filled with peace, happiness, and
              purpose.
            </p>
          </div>
        </div>
      </section>
      <section className="section-service-social">
        <div className="container">
          <h2 className="section-title font-work-sans d-md-none">
            <strong>Service and Social Initiatives</strong>
          </h2>
          <div className="section-content">
            <h2 className="section-title font-work-sans d-none d-md-block">
              <strong>Service and Social Initiatives</strong>
            </h2>
            <p>
              In collaboration with Art of Living’s partnership organization,
              the International Association for Human Values (IAHV), they have
              launched a wide array of humanitarian efforts, including conflict
              resolution, disaster relief, and sustainable growth in rural
              communities.
            </p>
            <Image
              src="/images/IahvLogoMobile.webp"
              alt="IAHV Logo"
              className="iahv-logo"
              width={130}
              height={59}
            />
          </div>
          <div className="section-image">
            <Image
              src="/images/IahvDesktop.jpeg"
              alt="IahvDesktop"
              className="iahv-desktop"
              width={484}
              height={320}
            />
          </div>
        </div>
      </section>
      <section className="section-initiatives">
        <div className="container">
          <h2 className="section-title font-work-sans">
            KEY <strong>INITIATIVES</strong>
          </h2>
          <div className="key-initiatives-container">
            {aboutKeyInitiatives.map((initiative, index) => (
              <div
                key={index}
                className="initiative-tile"
                style={{ background: initiative.bgcolor }}
              >
                <div className="ki-head">
                  <div className="ki-head-left">
                    <Image
                      src={initiative.icon}
                      alt={initiative.title}
                      width={80}
                      height={76}
                      className="initiative-icon"
                    />
                    <h3
                      dangerouslySetInnerHTML={{ __html: initiative.title }}
                    ></h3>
                  </div>
                  <div className="ki-head-right">
                    <Image
                      src={initiative.image}
                      alt={initiative.title}
                      width={122}
                      height={174}
                      className="initiative-image"
                    />
                  </div>
                </div>
                <div className="initiative-text">{initiative.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
